import { WorkspaceStatus } from '@lucidlink/dto/validation';
export const toWorkspaceViewModel = (data) => ({
    ...data,
    isOperational: data.status === WorkspaceStatus.ACTIVE ||
        data.status === WorkspaceStatus.TRIALING,
    isActive: data.status === WorkspaceStatus.ACTIVE,
    isTrialing: data.status === WorkspaceStatus.TRIALING,
    isSuspended: data.status === WorkspaceStatus.SUSPENDED,
});
export const toWorkspaceViewModels = (data) => data.map(toWorkspaceViewModel);
